import {Component, OnInit, AfterViewInit, ElementRef} from '@angular/core';
import {AuthenticationService} from "../shared/auth/authentication.service";
import {UserDetails} from "../shared/auth/user-details.model";


declare var $: any;

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit, AfterViewInit {

  private _modalRef:any;

  protected usernameFieldValue: string = '';
  protected pwdFieldValue: string = '';
  protected loginFailed: boolean = false;

  constructor(private _authService: AuthenticationService,
              private _rootNode: ElementRef) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this._modalRef = $(this._rootNode.nativeElement).find('#modalSubscription');
    this._modalRef.modal('show');
  }

  public OnLogin(): void {
    this.loginFailed = false;
    this._authService.login(this.usernameFieldValue, this.pwdFieldValue)
      .subscribe(
        data => {this.successfulLogin(data)},
        error => {}
      );
  }

  private successfulLogin(userDetails: UserDetails) {
    this.loginFailed = false;
  }

  private failedLogin() {
      this.loginFailed = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/signin/signin.component.ts